import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Scrollbars } from 'react-custom-scrollbars';

import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';

import * as labelConfigs from '../../../configs/labelConfigs';
import * as staticConfigs from '../../../configs/staticConfigs';

import {menuDeactiveAction} from '../../../actions/commonActions';
import { checkPermissions } from '../../../utils/permissions'; 

class SettingsComponent extends Component {

    static propTypes = {
        location: PropTypes.object.isRequired,
    };
    

    constructor(props){
        super(props)
        let userGroupData = userGroupUrlCheck(window.location);
        let lblCrew = 'Staff'
        if(userGroupData!==undefined){
            if(userGroupData.staff_name){
                lblCrew = userGroupData.staff_name; 
            }
        }  
        let superMenu = [
            // {name:labelConfigs.LBL_SKILLS,route:staticConfigs.ROUTE_SKILLS},
            // {name:labelConfigs.LBL_SECTORS,route:staticConfigs.ROUTE_SECTORS},
            // {name:labelConfigs.LBL_SUB_SECTORS,route:staticConfigs.ROUTE_SUB_SECTORS},
            // {name:labelConfigs.LBL_OTHER_EXPENSES,route:staticConfigs.ROUTE_OTHER_EXPENSES},
            // {name:labelConfigs.LBL_CLIENT+' '+labelConfigs.LBL_DOCUMENTS,route:staticConfigs.ROUTE_CLIENT_DOCS},
            // {name:labelConfigs.LBL_CREW+' '+labelConfigs.LBL_DOCUMENTS,route:staticConfigs.ROUTE_CREW_DOCS},
            // {name:labelConfigs.LBL_DYNAMIC+' '+labelConfigs.LBL_FIELDS+' for '+labelConfigs.LBL_CREW,route:staticConfigs.ROUTE_DYNAMIC_FIELDS_CREW},
            // {name:labelConfigs.LBL_DYNAMIC+' '+labelConfigs.LBL_FIELDS+' for '+labelConfigs.LBL_CLIENTS,route:staticConfigs.ROUTE_DYNAMIC_FIELDS_CLIENTS},
            // {name:labelConfigs.LBL_DYNAMIC+' '+labelConfigs.LBL_FIELDS+' for '+labelConfigs.LBL_AFFILIATES,route:staticConfigs.ROUTE_DYNAMIC_FIELDS_AFFILIATES},
            // {name:labelConfigs.LBL_PP_POINTS,route:staticConfigs.ROUTE_OMNU_POINTS},
            // {name:labelConfigs.LBL_OMNU_POINTS_AGAINST_PP,route:staticConfigs.ROUTE_OMNU_POINTS_SETTINGS},
            // {name:labelConfigs.LBL_EVENT_CANCEL_REASONS,route:staticConfigs.ROUTE_CANCEL_REASONS},
            // {name:labelConfigs.LBL_ROLES+' & '+labelConfigs.LBL_PERMISSIONS,route:staticConfigs.ROUTE_ROLES_PERMISSIONS}, 
            // {name:labelConfigs.LBL_TERMS_AND_CONDITIONS,route:staticConfigs.ROUTE_TERMS_AND_CONDITIONS},
            // {name:'Change Password',route:staticConfigs.ROUTE_CHANGE_PASSWORD},

        ];
        superMenu.push({name:labelConfigs.LBL_BASIC_CONFIGS,route:staticConfigs.ROUTE_BASIC_CONFIG}); 
        // if(checkPermissions('skills','view')){
        //     superMenu.push({name:labelConfigs.LBL_SKILLS,route:staticConfigs.ROUTE_SKILLS})
        // }
        if(checkPermissions('sector','view')){
            superMenu.push({name:labelConfigs.LBL_SECTORS,route:staticConfigs.ROUTE_SECTORS})
        }if(checkPermissions('subsector','view')){
            superMenu.push({name:labelConfigs.LBL_SUB_SECTORS,route:staticConfigs.ROUTE_SUB_SECTORS})
        }if(checkPermissions('otherexpenses','view')){
            superMenu.push({name:labelConfigs.LBL_OTHER_EXPENSES,route:staticConfigs.ROUTE_OTHER_EXPENSES})
        }

        

        { /* // ALL THESE MENUS ARE MOVED INTO A PAGE - BASIC CONFIG - 17Aug2022 
        // CLIENT CATEGORY ADDED - 16Aug2022
        if(!checkPermissions('clientcategories','view')){
            superMenu.push({name:labelConfigs.LBL_CLIENT_CATEGORIES,route:staticConfigs.ROUTE_CLIENT_CATEGORY})
        }
        if(checkPermissions('clientdocument','view')){
            superMenu.push({name:labelConfigs.LBL_CLIENT+' '+labelConfigs.LBL_DOCUMENTS,route:staticConfigs.ROUTE_CLIENT_DOCS})
        }if(checkPermissions('crewdocuments','view')){
            superMenu.push({name:labelConfigs.LBL_CREW+' '+labelConfigs.LBL_DOCUMENTS,route:staticConfigs.ROUTE_CREW_DOCS})
        }if(checkPermissions('dynfieldforclient','view')){
            superMenu.push({name:labelConfigs.LBL_DYNAMIC+' '+labelConfigs.LBL_FIELDS+' for '+labelConfigs.LBL_CLIENTS,route:staticConfigs.ROUTE_DYNAMIC_FIELDS_CLIENTS})
        }if(checkPermissions('dynfieldforcrew','view')){
            superMenu.push({name:labelConfigs.LBL_DYNAMIC+' '+labelConfigs.LBL_FIELDS+' for '+labelConfigs.LBL_CREW,route:staticConfigs.ROUTE_DYNAMIC_FIELDS_CREW})
        }if(checkPermissions('dynfieldforaffiliate','view')){
            superMenu.push({name:labelConfigs.LBL_DYNAMIC+' '+labelConfigs.LBL_FIELDS+' for '+labelConfigs.LBL_AFFILIATES,route:staticConfigs.ROUTE_DYNAMIC_FIELDS_AFFILIATES})
        }
        */ }
        
        if(checkPermissions('performancepoints','view')){
            superMenu.push({name:labelConfigs.LBL_PP_POINTS,route:staticConfigs.ROUTE_OMNU_POINTS})
        }if(checkPermissions('mnyhandspointsagainstpp','view')){
            superMenu.push({name:labelConfigs.LBL_OMNU_POINTS_AGAINST_PP,route:staticConfigs.ROUTE_OMNU_POINTS_SETTINGS})
        }if(checkPermissions('eventcancelreasons','view')){
            superMenu.push({name:labelConfigs.LBL_EVENT_CANCEL_REASONS,route:staticConfigs.ROUTE_CANCEL_REASONS})
        }if(checkPermissions('rolesandpermissions','view')){
            superMenu.push({name:labelConfigs.LBL_ROLES+' & '+labelConfigs.LBL_PERMISSIONS,route:staticConfigs.ROUTE_ROLES_PERMISSIONS})
        }if(checkPermissions('termsandconditions','view')){
            superMenu.push({name:labelConfigs.LBL_TERMS_AND_CONDITIONS,route:staticConfigs.ROUTE_TERMS_AND_CONDITIONS})
        }    
        
        

        let affiliateMenu = [
            //{name:labelConfigs.LBL_PROFILE,route:staticConfigs.ROUTE_AFFILIATE_PROFILE_MANAGE},
            // {name:labelConfigs.LBL_EVENT_LOCATIONS,route:staticConfigs.ROUTE_AFFILIATE_EVENT_LOCATIONS},
            // {name:labelConfigs.LBL_KEY_LOCATIONS,route:staticConfigs.ROUTE_AFFILIATE_KEY_LOCATIONS},
            // {name:labelConfigs.LBL_DEPARTMENTS,route:staticConfigs.ROUTE_AFFILIATE_DEPARTMENTS},
            // {name:labelConfigs.LBL_CLIENT_CATEGORIES,route:staticConfigs.ROUTE_AFFILIATE_CLIENT_CATEGORY},
            // {name:labelConfigs.LBL_CLIENT+' '+labelConfigs.LBL_DOCUMENTS,route:staticConfigs.ROUTE_AFFILIATE_CLIENT_DOCS},
            // {name:labelConfigs.LBL_CREW+' '+labelConfigs.LBL_DOCUMENTS,route:staticConfigs.ROUTE_AFFILIATE_CREW_DOCS},
            // {name:labelConfigs.LBL_DYNAMIC+ ' '+labelConfigs.LBL_FIELDS+' for '+labelConfigs.LBL_CLIENTS,route:staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS},
            // {name:labelConfigs.LBL_DYNAMIC+ ' '+labelConfigs.LBL_FIELDS+' for '+lblCrew,route:staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW},
            // {name:labelConfigs.LBL_VEHICLE_INFO,route:staticConfigs.ROUTE_AFFILIATE_VEHICLE_INFO},
            // {name:labelConfigs.LBL_SKILLS,route:staticConfigs.ROUTE_AFFILIATE_SKILLS},
            // {name:labelConfigs.LBL_MASTER_RATE_CARD,route:staticConfigs.ROUTE_AFFILIATE_MASTER_RATE_CARD},
            //{name:'Set '+labelConfigs.LBL_APPAYRATE,route:staticConfigs.ROUTE_AFFILIATE_XP_PAY_RATE},
            // {name:labelConfigs.LBL_PAY_LEVELS,route:staticConfigs.ROUTE_AFFILIATE_PAY_LEVELS},
            // {name:labelConfigs.LBL_OTHER_EXPENSES,route:staticConfigs.ROUTE_AFFILIATE_OTHER_EXPENSES},
            // {name:labelConfigs.LBL_EVENT_CANCEL_REASONS,route:staticConfigs.ROUTE_AFFILIATE_CANCEL_REASONS},
            // {name:labelConfigs.LBL_ROLES+' & '+labelConfigs.LBL_PERMISSIONS,route:staticConfigs.ROUTE_AFFILIATE_ROLES_PERMISSIONS},
            // {name:labelConfigs.LBL_CERTIFICATES,route:staticConfigs.ROUTE_AFFILIATE_CERTIFICATES},
            // {name:labelConfigs.LBL_CSV_TEMPLATES_DOWNLOAD,route:staticConfigs.ROUTE_AFFILIATE_CSV_TEMPLATES},
            // {name:labelConfigs.LBL_INVITE_A_FRIEND,route:staticConfigs.ROUTE_AFFILIATE_INVITE_FRIEND},
            // {name:labelConfigs.LBL_CHANGE_PASSWORD,route:staticConfigs.ROUTE_AFFILIATE_CHANGE_PASSWORD},
        ];
        affiliateMenu.push({name:labelConfigs.LBL_BASIC_CONFIGS,route:staticConfigs.ROUTE_AFFILIATE_BASIC_CONFIG}); 
        if(checkPermissions('eventlocations','view')){
            affiliateMenu.push({name:labelConfigs.LBL_EVENT_LOCATIONS,route:staticConfigs.ROUTE_AFFILIATE_EVENT_LOCATIONS})
        }if(checkPermissions('keylocations','view')){
            affiliateMenu.push({name:labelConfigs.LBL_KEY_LOCATIONS,route:staticConfigs.ROUTE_AFFILIATE_KEY_LOCATIONS})
        }if(checkPermissions('settingsdepartments','view')){
            affiliateMenu.push({name:labelConfigs.LBL_DEPARTMENTS,route:staticConfigs.ROUTE_AFFILIATE_DEPARTMENTS})
        } 

        

        {/* // ALL THESE MENUS ARE MOVED INTO A PAGE - BASIC CONFIG - 17Aug2022 
        if(checkPermissions('clientcategories','view')){
            affiliateMenu.push({name:labelConfigs.LBL_CLIENT_CATEGORIES,route:staticConfigs.ROUTE_AFFILIATE_CLIENT_CATEGORY})
        }if(checkPermissions('clientdocument','view')){
            affiliateMenu.push({name:labelConfigs.LBL_CLIENT+' '+labelConfigs.LBL_DOCUMENTS,route:staticConfigs.ROUTE_AFFILIATE_CLIENT_DOCS})
        }if(checkPermissions('crewdocuments','view')){
            affiliateMenu.push({name:labelConfigs.LBL_CREW+' '+labelConfigs.LBL_DOCUMENTS,route:staticConfigs.ROUTE_AFFILIATE_CREW_DOCS})
        }if(checkPermissions('dynfieldforclient','view')){
            affiliateMenu.push({name:labelConfigs.LBL_DYNAMIC+ ' '+labelConfigs.LBL_FIELDS+' for '+labelConfigs.LBL_CLIENTS,route:staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS})
        }if(checkPermissions('dynfieldforcrew','view')){
            affiliateMenu.push({name:labelConfigs.LBL_DYNAMIC+ ' '+labelConfigs.LBL_FIELDS+' for '+lblCrew,route:staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW})
        }if(checkPermissions('skills','view')){
            affiliateMenu.push({name:labelConfigs.LBL_SKILLS,route:staticConfigs.ROUTE_AFFILIATE_SKILLS})
        }
        */}
        //if(checkPermissions('masterratecard','view')){
        //     affiliateMenu.push({name:labelConfigs.LBL_MASTER_RATE_CARD,route:staticConfigs.ROUTE_AFFILIATE_MASTER_RATE_CARD})
        // }
        if(checkPermissions('vehicleinfo','view')){
            affiliateMenu.push({name:labelConfigs.LBL_VEHICLE_DETAILS,route:staticConfigs.ROUTE_AFFILIATE_VEHICLE_DETAILS})
        }
        if(checkPermissions('masterratecard','view')){
            affiliateMenu.push({name:labelConfigs.LBL_RATE_CARDS,route:staticConfigs.ROUTE_AFFILIATE_RATECARDS})
        }if(checkPermissions('paylevels','view')){
            affiliateMenu.push({name:labelConfigs.LBL_PAY_LEVELS,route:staticConfigs.ROUTE_AFFILIATE_PAY_LEVELS})
        }if(checkPermissions('otherexpenses','view')){
            affiliateMenu.push({name:labelConfigs.LBL_OTHER_EXPENSES,route:staticConfigs.ROUTE_AFFILIATE_OTHER_EXPENSES})
        }if(checkPermissions('eventcancelreasons','view')){
            affiliateMenu.push({name:labelConfigs.LBL_EVENT_CANCEL_REASONS,route:staticConfigs.ROUTE_AFFILIATE_CANCEL_REASONS})
        }if(checkPermissions('rolesandpermissions','view')){
            affiliateMenu.push({name:labelConfigs.LBL_ROLES+' & '+labelConfigs.LBL_PERMISSIONS,route:staticConfigs.ROUTE_AFFILIATE_ROLES_PERMISSIONS})
        }if(checkPermissions('csvtemplatesdownload','view')){
            affiliateMenu.push({name:labelConfigs.LBL_CSV_TEMPLATES_DOWNLOAD,route:staticConfigs.ROUTE_AFFILIATE_CSV_TEMPLATES})
        }
        // if(checkPermissions('inviteafriend','view')){
        //     affiliateMenu.push({name:labelConfigs.LBL_INVITE_A_FRIEND,route:staticConfigs.ROUTE_AFFILIATE_INVITE_FRIEND})
        // }


        let clientMenu = [            
            {name:'Change Password',route:staticConfigs.ROUTE_CLIENT_CHANGE_PASSWORD},
        ];
        
        this.state = {
            superMenu:superMenu,
            affiliateMenu:affiliateMenu,
            clientMenu:clientMenu,
            active:''
        }
        this.onClickMenu = this.onClickMenu.bind(this);
    }
    
    onHideSettings = () => {
        document.getElementById("right-menu-content").classList.remove('active');
    }

    onClickMenu = (e) => {
        this.setState({ active: e.currentTarget.id });
        this.props.menuDeactiveAction(e.currentTarget.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.menuActive !== prevProps.menuActive) {
            this.setState({ active: this.props.menuActive})
        }
    }

    render(){

        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        if (location.pathname === '/' || location.pathname === staticConfigs.LOGIN_ROUTE_SUPER_ADMIN || location.pathname === staticConfigs.LOGIN_ROUTE_AFFILIATE || location.pathname === staticConfigs.LOGIN_ROUTE_CLIENT) return null;
        
        return(
            <div className='right-menu-content' id='right-menu-content' >
                <ul>
                    <li className="head">
                        <h2>{labelConfigs.LBL_SETTINGS}  <button className={userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP ? "close-right-menu-aflt" : "close-right-menu"} onClick={this.onHideSettings}> <span aria-hidden="true">&times;</span></button></h2>
                    </li>
                </ul>
                
                <div className="settings-menu">
                <Scrollbars 
                    style={{ "height": "85vh", "marginTop":7}}
                    autoHide
                    renderTrackHorizontal={props => <div {...props} style={{display: 'none'}} className="track-horizontal"/>}
                    renderView={props => (
                        <div {...props} style={{ ...props.style, overflowX: 'hidden' }} />
                    )}
                    >
                    { (userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP) && 
                        <ul onClick={this.onHideSettings} className="menuLineHeight">                            
                            {
                            this.state.superMenu.map((item,index)  => {
                                return(
                                    <li id={item.name} className={this.state.active === item.name ? 'active' : ''} onClick={(e) => this.onClickMenu(e)} key={index}>
                                    <Link to={item.route}>{item.name}</Link>
                                    </li>
                                )
                            })  
                            }                   
                        </ul>
                    } 
                    { (userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP) && 
                        <ul onClick={this.onHideSettings} className="menuLineHeight">    
                            {
                            this.state.affiliateMenu.map((item,index)  => {
                                return(
                                    <li id={item.name} className={this.state.active === item.name ? 'active' : ''} onClick={(e) => this.onClickMenu(e)} key={index}>
                                    <Link to={item.route}>{item.name}</Link>
                                    </li>
                                )
                            })  
                            }  
                        </ul>
                    } 
                    { (userGroup===staticConfigs.LOGIN_CLIENT_GROUP) && 
                        <ul onClick={this.onHideSettings} className="menuLineHeight">    
                            {
                            this.state.clientMenu.map((item,index)  => {
                                return(
                                    <li id={item.name} className={this.state.active === item.name ? 'active' : ''} onClick={(e) => this.onClickMenu(e)} key={index}>
                                    <Link to={item.route}>{item.name}</Link>
                                    </li>
                                )
                            })  
                            }  
                        </ul>
                    } 
                    <div>&nbsp;</div>
                    </Scrollbars>
                </div>
                
            </div>
        )
    }
    
}

const mapStateToProps = (state) => {
    return {
        menuActive: state.commons.menuActive   
    } 
};
 
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        menuDeactiveAction:menuDeactiveAction  
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps) (withRouter(SettingsComponent));